const routes = [
    {
        path: '/assinatura_digital/relatorios',
        alias: '/assinatura_digital/relatorios/index',
        component: () => import('../views/Listar')
    },
    {
        path: '/assinatura_digital/relatorios/documentos',
        component: () => import('../views/Documentos')
    }
    ,
    {
        path: '/assinatura_digital/relatorios/contatos',
        component: () => import('../views/Contatos')
    }
]

export default routes
